var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPosterOneWide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58.36 40.01"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ededed",
    d: "M0 0h58.36v40.01H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2da343",
    d: "M5.4 4.42h47.56v31.17H5.4z"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1OC4zNiA0MC4wMSI+DQogIDxnIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiPg0KICAgIDxnIGlkPSJMYXllcl8xLTIiIGRhdGEtbmFtZT0iTGF5ZXIgMSI+DQogICAgICA8Zz4NCiAgICAgICAgPHJlY3Qgd2lkdGg9IjU4LjM2IiBoZWlnaHQ9IjQwLjAxIiBzdHlsZT0iZmlsbDogI2VkZWRlZCIvPg0KICAgICAgICA8cmVjdCB4PSI1LjQiIHk9IjQuNDIiIHdpZHRoPSI0Ny41NiIgaGVpZ2h0PSIzMS4xNyIgc3R5bGU9ImZpbGw6ICMyZGEzNDMiLz4NCiAgICAgIDwvZz4NCiAgICA8L2c+DQogIDwvZz4NCjwvc3ZnPg0K";
export { SvgPosterOneWide as ReactComponent };